var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch2\u003EManage Teams\u003C\u002Fh2\u003E";;return pug_html;};
module.exports = template;